<script lang="ts" generics="T extends { id: number }">
  interface Column<T> {
    key: {
      [K in keyof T]: T[K] extends string | number | null | undefined ? K : never
    }[keyof T] &
      string
    label: string
  }

  interface Props {
    items: T[]
    columns: Column<T>[]
    onEdit?: (item: T) => void
    onDelete?: (id: number) => void
    loading?: boolean
  }

  const { items, columns, onEdit, onDelete, loading = false }: Props = $props()
</script>

<table class="admin-table">
  <thead>
    <tr>
      {#each columns as col (col.key)}
        <th>{col.label}</th>
      {/each}
      {#if onEdit || onDelete}
        <th class="actions-header">Actions</th>
      {/if}
    </tr>
  </thead>
  <tbody>
    {#if loading && items.length === 0}
      <tr>
        <td colspan={columns.length + (onEdit || onDelete ? 1 : 0)} class="loading-cell">
          Loading…
        </td>
      </tr>
    {:else if items.length === 0}
      <tr>
        <td colspan={columns.length + (onEdit || onDelete ? 1 : 0)} class="empty-cell">
          No records.
        </td>
      </tr>
    {:else}
      {#each items as item (item.id)}
        <tr>
          {#each columns as col (col.key)}
            <td>{item[col.key] ?? '-'}</td>
          {/each}
          {#if onEdit || onDelete}
            <td class="actions-cell">
              {#if onEdit}
                <button type="button" onclick={() => onEdit(item)}>Edit</button>
              {/if}
              {#if onDelete}
                <button type="button" class="danger" onclick={() => onDelete(item.id)}>
                  Delete
                </button>
              {/if}
            </td>
          {/if}
        </tr>
      {/each}
    {/if}
  </tbody>
</table>

<style>
  .admin-table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
  }
  th,
  td {
    padding: 8px 12px;
    border-bottom: 1px solid var(--line);
    text-align: left;
  }
  th {
    background: var(--surface);
    font-weight: 600;
    font-size: 0.875rem;
  }
  .actions-cell,
  .actions-header {
    text-align: right;
    white-space: nowrap;
  }
  .actions-cell button {
    margin-left: 4px;
    padding: 4px 8px;
    border: 1px solid var(--line-strong);
    background: var(--surface-2);
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.875rem;
  }
  .actions-cell button:hover {
    background: var(--surface-3);
  }
  .actions-cell button.danger {
    color: var(--err-ink);
    border-color: var(--err-line);
  }
  .actions-cell button.danger:hover {
    background: var(--err-bg);
  }
  .loading-cell,
  .empty-cell {
    text-align: center;
    padding: 24px;
    color: var(--muted);
  }
</style>
